module.exports = __webpack_public_path__ + "img/NotifySuccess.49d2930f.svg";